import { pushDataLayerBudgetEvent } from 'assets/core/js/page/product/search/filters/datalayer'
import budgetSlider from 'assets/core/js/page/search/budgetSlider'
import submitFilterForm from './submitFilterForm'

export default function (): void {
  budgetSlider({
    callbackChange: (value: string) => {
      pushDataLayerBudgetEvent(value)

      submitFilterForm()
    },
  })
}
